/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface UpdatedBy
 */
export interface UpdatedBy {}

/**
 * Check if a given object implements the UpdatedBy interface.
 */
export function instanceOfUpdatedBy(value: object): boolean {
    return true;
}

export function UpdatedByFromJSON(json: any): UpdatedBy {
    return UpdatedByFromJSONTyped(json, false);
}

export function UpdatedByFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatedBy {
    return json;
}

export function UpdatedByToJSON(value?: UpdatedBy | null): any {
    return value;
}
